import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=bdc68152&scoped=true"
import script from "./rules.vue?vue&type=script&lang=js"
export * from "./rules.vue?vue&type=script&lang=js"
import style0 from "./rules.vue?vue&type=style&index=0&id=bdc68152&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc68152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc68152')) {
      api.createRecord('bdc68152', component.options)
    } else {
      api.reload('bdc68152', component.options)
    }
    module.hot.accept("./rules.vue?vue&type=template&id=bdc68152&scoped=true", function () {
      api.rerender('bdc68152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/CallMotivation/rules.vue"
export default component.exports